module.exports = __webpack_public_path__ + "img/slide-29.25702d8f.jpg";